import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import {
  FaBriefcase,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaUser,
  FaSignOutAlt,
} from "react-icons/fa";
import "./menubar.css";

function Menubar() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [expanded, setExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [user, setUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [addressForm, setAddressForm] = useState({
    pincode: "",
    state: "",
    district: "",
  });

  const [filter, setFilter] = useState(""); // search input
  const [categories, setCategories] = useState([]); // categories from API
  const [suggestions, setSuggestions] = useState([]); // filtered suggestions
  const inputRef = useRef(null);

  const navigate = useNavigate();

  // Detect screen resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (!mobile) {
        setExpanded(false);
        setActiveDropdown(null);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get user's current location
  const getMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        fetch(`${API_URL}/user/location/${lat}/${lng}`)
          .then((res) => res.json())
          .then((serverResponse) => {
            const address = serverResponse.address || {};
            setAddressForm({
              pincode: address.postcode || "",
              state: address.state || "",
              district: address.county || address.city || address.town || "",
            });
          })
          .catch((err) => console.error("Error fetching location:", err));
      });
    }
  };
  useEffect(() => {
  getMyLocation();
  const loadUser = () => {
    const storedUser = sessionStorage.getItem("user");
    setUser(storedUser ? JSON.parse(storedUser) : null);
    window.dispatchEvent(new CustomEvent("userUpdated"));
  };
  loadUser();
  const handleUserUpdate = () => loadUser();
  window.addEventListener("userUpdated", handleUserUpdate);
  return () => {
    window.removeEventListener("userUpdated", handleUserUpdate);
  };
}, []);

  // Fetch categories for search suggestions
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${API_URL}/catagory`);
        const data = await res.json();
        const categoryNames = data.map((cat) =>
          typeof cat === "string" ? cat : cat.name || ""
        );
        setCategories(categoryNames); // array of category names
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    };
    fetchCategories();
  }, [API_URL]);

  // Handle input change
  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);

    if (value.length > 0) {
      const filtered = categories.filter((cat) =>
        typeof cat === "string" && cat.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  // Handle search
  const handleSearch = (value) => {
    navigate(`/typesoffunction?query=${encodeURIComponent(value)}`);
    setSuggestions([]);
    setFilter("");
  };

  const handleSuggestionClick = (value) => {
    setFilter(value);
    handleSearch(value);
    closeMenu();
  };

  // Close suggestions on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Dropdown handlers
  const handleDropdownToggle = (dropdown) => {
    if (isMobile) {
      setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
    }
  };

  const handleDropdownHover = (dropdown) => {
    if (!isMobile) setActiveDropdown(dropdown);
  };

  const handleDropdownLeave = () => {
    if (!isMobile) setActiveDropdown(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("user");
    setUser(null);
    setExpanded(false);
    navigate("/loginsignup");
  };

  const closeMenu = () => {
    setExpanded(false);
    setActiveDropdown(null);
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="wedding-navbar"
        fixed="top"
        expanded={expanded}
      >
        <div className="navbar-header-flex">
          <Navbar.Brand as={Link} to="/" className="navbar-brand" onClick={closeMenu}>
            VAIBHAVAM
          </Navbar.Brand>
           <Navbar.Toggle
    aria-controls="main-navbar"
    onClick={() => setExpanded(!expanded)}
    className="navbar-toggler-custom"
  >
    {expanded ? <FaTimes /> : <span>&#9776;</span>}
  </Navbar.Toggle>

          {!isMobile && addressForm.district && (
            <div className="city-indicator">
              📍 Location: <b>{addressForm.district}, {addressForm.state}</b>
            </div>
          )}

        


          <Navbar.Collapse id="main-navbar" className={expanded ? "show" : ""}>
                      {/* Search Box - Centered with max width */}
<div className="search-box">
  <input
    type="text"
    placeholder="Search"
    value={filter}
    onChange={handleFilterChange}
    ref={inputRef}
    onKeyDown={(e) => {
      if (e.key === "Enter") handleSearch(filter);
    }}
  />
  {suggestions.length > 0 && (
    <ul className="suggestions-list">
      {suggestions.map((item, index) => (
        <li key={index} className="suggestion-item" onClick={() => handleSuggestionClick(item)}>
          {item}
        </li>
      ))}
    </ul>
  )}
</div>


            <div className="mobile-menu-header">
              {isMobile && addressForm.district && (
                <div className="mobile-city-indicator">
                  📍 Location: <b>{addressForm.district}, {addressForm.state}</b>
                </div>
              )}
              {isMobile && (
                <button className="close-menu-btn" onClick={closeMenu}>
                  <FaTimes />
                </button>
              )}
            </div>

            {/* Nav Links */}
            <Nav className="navbar-nav me-auto">
              <Nav.Link as={Link} to="/" className="nav-link" onClick={closeMenu}>
                Home
              </Nav.Link>

              <NavDropdown
                title={
                  <>
                    Info
                    {isMobile &&
                      (activeDropdown === "info" ? (
                        <FaChevronUp className="dropdown-chevron" />
                      ) : (
                        <FaChevronDown className="dropdown-chevron" />
                      ))}
                  </>
                }
                id="info-dropdown"
                className="mega-dropdown"
                show={activeDropdown === "info"}
                onMouseEnter={() => handleDropdownHover("info")}
                onMouseLeave={handleDropdownLeave}
                onClick={() => handleDropdownToggle("info")}
              >
                <div className="mega-menu-container">
                  <div className="mega-menu-column">
                    <div className="mega-menu-header">INFORMATION</div>
                    <Link to="/about" className="mega-menu-item" onClick={closeMenu}>
                      About
                    </Link>
                    <Link to="/terms" className="mega-menu-item" onClick={closeMenu}>
                      Terms and Conditions
                    </Link>
                    <Link to="/PrivacyPolicy" className="mega-menu-item" onClick={closeMenu}>
                  Privacy Policy                    
                  </Link>
                    <Link to="/policy" className="mega-menu-item" onClick={closeMenu}>
                      Refund and Cancellation Policy
                    </Link>
                    {/* <Link to="/invoice" className="mega-menu-item" onClick={closeMenu}>
                      Invoice
                    </Link> */}
                  </div>
                </div>
              </NavDropdown>

              <Nav.Link as={Link} to="/venue" className="nav-link" onClick={closeMenu}>
                Venues
              </Nav.Link>
              <Nav.Link as={Link} to="/vendor" className="nav-link" onClick={closeMenu}>
                Vendors
              </Nav.Link>

              {user && (
                <>
                  {["user", "venueProvider", "vendorProvider"].includes(user?.role) && (
                    <Nav.Link as={Link} to="/ProfilePage" className="nav-link" onClick={closeMenu}>
                      Profile
                    </Nav.Link>
                  )}

                  {user.role === "venueProvider" && (
                    <>
                      <Nav.Link as={Link} to="/VenueForm" className="nav-link" onClick={closeMenu}>
                        Manage Venues
                      </Nav.Link>
                    
                    </>
                  )}

                  {user.role === "vendorProvider" && (
                    <Nav.Link as={Link} to="/VendorForm" className="nav-link" onClick={closeMenu}>
                      Manage Vendors
                    </Nav.Link>
                  )}

                  {user && (
  <>
    {/* User: My Orders */}
    {user.role === "user" && (
      <Nav.Link as={Link} to="/MyOrders" className="nav-link" onClick={closeMenu}>
        My Orders
      </Nav.Link>
    )}

    {/* Venue Provider & Vendor Provider: My Bookings */}
    {["venueProvider", "vendorProvider"].includes(user.role) && (
      <Nav.Link as={Link} to="/MyOrders" className="nav-link" onClick={closeMenu}>
        My Bookings
      </Nav.Link>
    )}

    {/* Admin: All Orders */}
    {user.role === "admin" && (
      <Nav.Link as={Link} to="/MyOrders" className="nav-link" onClick={closeMenu}>
        All Orders
      </Nav.Link>
    )}
  </>
)}


                  {user.role === "admin" && (
                    <NavDropdown
                      title={
                        <>
                          Admin
                          {isMobile &&
                            (activeDropdown === "admin" ? (
                              <FaChevronUp className="dropdown-chevron" />
                            ) : (
                              <FaChevronDown className="dropdown-chevron" />
                            ))}
                        </>
                      }
                      id="admin-dropdown"
                      className="mega-dropdown"
                      show={activeDropdown === "admin"}
                      onMouseEnter={() => handleDropdownHover("admin")}
                      onMouseLeave={handleDropdownLeave}
                      onClick={() => handleDropdownToggle("admin")}
                    >
                      <div className="mega-menu-container">
                        <div className="mega-menu-column">
                          <div className="mega-menu-header">CATEGORY MANAGEMENT</div>
                          <Link to="/CategoryForm" className="mega-menu-item" onClick={closeMenu}>
                            Category Form
                          </Link>
                          <Link to="/addcatagory" className="mega-menu-item" onClick={closeMenu}>
                            Add Category
                          </Link>
                          <Link to="/typesoffunction" className="mega-menu-item" onClick={closeMenu}>
                            Types of Functions
                          </Link>
                          <Link to="/FunctionForm" className="mega-menu-item" onClick={closeMenu}>
                            Function Form
                          </Link>
                          <Link to="/VenueForm" className="mega-menu-item" onClick={closeMenu}>
                            Venue Form
                          </Link>
                          <Link to="/VendorForm" className="mega-menu-item" onClick={closeMenu}>
                            Vendor Form
                          </Link>
                          {/* <Link to="/AllOrders" className="mega-menu-item" onClick={closeMenu}>
                            All Orders
                          </Link> */}
                        </div>
                      </div>
                    </NavDropdown>
                  )}

                  {/* Logout */}
                  <Nav.Link
                    as="button"
                    className="logout-link"
                    onClick={() => {
                      handleLogout();
                      closeMenu();
                    }}
                  >
                    <FaSignOutAlt className="logout-icon" /> Logout
                  </Nav.Link>
                </>
              )}
            </Nav>

            {/* Right Section */}
            <div className="d-flex align-items-center ms-auto nav-right-section">
              <div className="vendor-section me-3">
                <div className="vendor-content">
                  <div className="vendor-title">
                    <FaBriefcase className="vendor-icon" />
                    {user ? (
                      <span>Welcome, {user.name}</span>
                    ) : (
                      <span>VENDOR / VENUE PROVIDER?</span>
                    )}
                  </div>
                </div>
              </div>

              {user && (
                <Link to="/ProfilePage" className="profile-icon-link" onClick={closeMenu}>
                  <FaUser className="profile-icon" />
                </Link>
              )}

              {!user && (
                <div className="auth-buttons d-flex gap-3 me-4">
                  <Nav.Link as={Link} to="/loginsignup" className="nav-link" onClick={closeMenu}>
                    Login
                  </Nav.Link>
                  <Nav.Link as={Link} to="/registration" className="nav-link" onClick={closeMenu}>
                    Register
                  </Nav.Link>
                </div>
              )}
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
}

export default Menubar;